module.exports = __webpack_public_path__ + "static/media/Debentures-Hub-logo.82a9372d.svg";